import { toast } from "react-toastify";
import { MenuAPI } from "../constants/apiRoutes";
import { menuActions } from "../reducers/menu";
import apiService from "../utils/configAxios";
import { handleError } from "../utils/handleError";

export const fetchMenuFormList = () => {
  return (dispatch) => {
    return apiService
      .get(MenuAPI.form())
      .then((response) => {
        dispatch(menuActions.fetchMenuFormList(response.data));
      })
      .catch((err) => {
        handleError(err);
      });
  };
};
